var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-connection"},[_c('h1',[_vm._v(_vm._s(_vm.$t('example')))]),_vm._v(" "+_vm._s(_vm.plkConnection$)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }